<template>
    <div class="limited-spots-in-page__nest">
        <div class="limited-spots-in-page__text">
            <div class="limited-spots-in-page__title">{{ $t('sales.limitedAvability') }}</div>
            <div class="limited-spots-in-page__sale">{{ product.sale_name }}</div>
        </div>
        <div class="limited-spots-in-page__spots">
            <template v-if="currentLanguage === 'es'">
                {{ $t('sales.left') }}
            </template>
            <span class="limited-spots-in-page__remaining">{{ remainingSpots }}</span>
            {{ spots }}
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters(['product']),
        ...mapState({
            remainingSpots: (state) => state.remainingSpots,
        }),
        currentLanguage() {
            return window.App.language;
        },
        spots() {
            if (['de', 'es'].includes(this.currentLanguage)) {
                return this.remainingSpots === 1 ? this.$t('sales.spot') : this.$t('sales.spots');
            }
            return `${this.remainingSpots === 1 ? this.$t('sales.spot') : this.$t('sales.spots')} ${this.$t('sales.left')}`;
        },
    },
};
</script>
